import { Show } from "solid-js";
import { getStoredPropertyType } from "../utils/accessToken";
import ResidentialHome from "./home/ResidentialHome";
import HotelHome from "./home/HotelHome";

// Hotel properties get their own home screen; everything else (residential,
// or a token without a property type) keeps the regular home.
const HomePage = () => (
  <Show when={getStoredPropertyType() === "hotel"} fallback={<ResidentialHome />}>
    <HotelHome />
  </Show>
);

export default HomePage;
